<!--suppress HtmlUnknownBooleanAttribute -->
<mat-toolbar style="background-color: #101820FF">
  <div fxHide.gt-xs>
    <button  mat-icon-button (click)="onToggleSidenav()">
      <mat-icon color="warn">menu</mat-icon>
    </button>
  </div>
  <div>
    <a routerLink="/">
      NG-Covid
    </a>
  </div>
  <div fxLayout fxFlex fxLayoutAlign="end" fxHide.xs>
    <ul fxLayout fxLayoutGap="15px">
      <li>
        <a mat-button routerLink="/charts">
          <img src="../../../../assets/img/chart-icon.png" style="width: 50px;" alt="Chart icon">
          Charts
        </a>
      </li>
      <li>
        <a mat-button routerLink="/therapeutics">
          <img src="../../../../assets/img/pill.png" style="width: 30px; margin-right: 10px" alt="Pill icon">
          <span>Therapeutics</span>
        </a>
      </li>
      <li>
        <a mat-button routerLink="/vaccines">
          <img src="../../../../assets/img/vaccine-icon.png" style="width: 30px; margin-right: 10px" alt="Vaccine icon">
          <span>Vaccines</span>
        </a>
      </li>
    </ul>
  </div>
</mat-toolbar>

